import { ActionArgs } from '../action/ActionArgs'
import { Field, InputType } from 'type-graphql'

@InputType()
export class UpdateTemplatesFavoriteServiceArgs extends ActionArgs {
  @Field(() => String)
  value: string
}
